import { Form } from 'react-bootstrap'

const ClubNumberInput = (props) => {
  const {
    setValue,
    value,
    setError
  } = props

  const handleOnChange = (e) => {
    setValue(e.target.value.toUpperCase())
    setError("")
  }

  return (
    <Form.Group className="mb-2 w-100" controlId="clubNumber">
      <Form.Control
        onChange={handleOnChange}
        value={value}
      />
    </Form.Group>
  )
}

export default ClubNumberInput